<div class="cf-dlg" [class.cba-page]="!dialogRef">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>credit_card</mat-icon></div>
    <div class="cba-header-text">
      <h2 class="cf-dlg-title">{{ isEdit ? 'Editar cuenta bancaria' : 'Nueva cuenta bancaria' }}</h2>
      <p class="cf-dlg-subtitle">Datos de la cuenta asociada al contacto</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando cuenta bancaria…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" message="Guardando cuenta bancaria…"></app-loading-state>

  <ng-container *ngIf="ready && !saving">
    <form class="cba-form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <span class="cf-dlg-section__label">Datos bancarios</span>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && (missingIban || invalidIban)">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>IBAN</mat-label>
            <input matInput name="iban" [(ngModel)]="contactBankAccount.iban" placeholder="ES00 0000 0000 0000 0000 0000"
              autocomplete="off" cdkFocusInitial>
            <mat-icon matSuffix>account_balance</mat-icon>
          </mat-form-field>
          <div class="cf-field__error" *ngIf="submitted && missingIban"><mat-icon>error</mat-icon> Indica el IBAN</div>
          <div class="cf-field__error" *ngIf="submitted && invalidIban"><mat-icon>error</mat-icon> El IBAN no es válido</div>
        </div>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingBank">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Entidad</mat-label>
              <input matInput name="bank" [(ngModel)]="contactBankAccount.bank" autocomplete="off">
            </mat-form-field>
            <div class="cf-field__error" *ngIf="submitted && missingBank"><mat-icon>error</mat-icon> Indica la entidad</div>
          </div>

          <div [class.cf-field--invalid]="submitted && invalidSwift">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>BIC / SWIFT</mat-label>
              <input matInput name="swift" [(ngModel)]="contactBankAccount.swift" placeholder="XXXXESMMXXX" autocomplete="off">
            </mat-form-field>
            <div class="cf-field__error" *ngIf="submitted && invalidSwift"><mat-icon>error</mat-icon> El BIC/SWIFT no es válido</div>
          </div>
        </div>

        <div class="cba-toggle">
          <mat-slide-toggle name="remesa" [(ngModel)]="contactBankAccount.remesa">
            Principal en domiciliación bancaria
          </mat-slide-toggle>
          <span class="cba-toggle__hint">Se usará por defecto en las remesas de este contacto.</span>
        </div>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary">
          <mat-icon>save</mat-icon> Guardar
        </button>
      </div>
    </form>
  </ng-container>
</div>
